<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center">
      <h1 class="font-semibold text-2xl my-5">
        {{ psycology_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ psycology_title_subtitle.subtitle }}
      </p>
    </div>
    <template v-if="['free'].includes(roleUser)">
      <UpgradePlans
        :text="' psychology tricks to convert users into customers'"
      />
      <div
        class="lock tips__wrapper flex gap-10 py-4 justify-center justify-items-center lg:py-10"
        v-if="true"
      >
        <div
          @click="selectTip(1)"
          class="cursor-pointer button__tips flex flex-col items-center bg-blue-100 justify-center w-72 h-72 rounded-lg px-8 py-10"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-blue-900"
          >
            Cognitive biases and principles that affect your marketing
          </h2>
          <Icon
            viewbox="0 0 74.342 71.113"
            fill="text-blue-900"
            name="Laptop"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div
          @click="selectTip(2)"
          class="cursor-pointer button__tips flex flex-col items-center justify-center w-72 h-72 rounded-lg px-8 py-10 bg-blue-900"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-white"
          >
            Behavioral biases to boost your sales
          </h2>
          <Icon
            viewbox="0 0 74.342 71.113"
            fill="#fff"
            name="Laptop"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="!['free'].includes(roleUser)">
      <div
        class="tips__wrapper flex gap-10 py-4 justify-center justify-items-center lg:py-10"
        v-if="true"
      >
        <div
          @click="selectTip(1)"
          class="cursor-pointer button__tips flex flex-col items-center bg-blue-100 justify-center w-72 h-72 rounded-lg px-8 py-10"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-blue-900"
          >
            Cognitive biases and principles that affect your marketing
          </h2>
          <Icon
            viewbox="0 0 74.342 71.113"
            fill="text-blue-900"
            name="Laptop"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div
          @click="selectTip(2)"
          class="cursor-pointer button__tips flex flex-col items-center justify-center w-72 h-72 rounded-lg px-8 py-10 bg-blue-900"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-white"
          >
            Behavioral biases to boost your sales
          </h2>
          <Icon
            viewbox="0 0 74.342 71.113"
            fill="#fff"
            name="Laptop"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </template>

    <div
      class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      v-else
    >
      <div>
        <h2 class="text-4xl font-semibold mb-4">
          There aren't Psychology Tips and Tricks 💔
        </h2>
        <p class="mb-10 text-lg">
          We recommend you check the completed library and select the awesome
          ads for you
        </p>
        <router-link to="/" class="flex justify-center">
          <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
            >Go To Ads Library</Button
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Button from "@/components/UI/Button";
import UpgradePlans from "@/components/UpgradePlans";
import { useRouter } from "vue-router";

export default {
  components: { HeaderApp, AdblockTopbar, Button, UpgradePlans, Icon },
  setup() {
    const store = useStore();
    const router = useRouter();
    let selectedTip = ref(null);
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });
    const selectTip = (tip) => {
      router.push("/psychology/" + tip);
    };
    const roleUser = computed(() => store.state.role);
    const psycology_title_subtitle = computed(
      () => store.state.psycologyTitleSubtitle
    );
    return { roleUser, psycology_title_subtitle, selectedTip, selectTip };
  },
};
</script>

<style scoped>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.tips__wrapper {
  @apply grid;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.button__tips {
  border-radius: 20px;
}
.button__tips-text::before {
  display: block;
  content: " ";
  height: 3px;
  width: 20%;
  position: absolute;
  left: 40%;
  top: -15px;
  margin-bottom: 10px;
  margin-right: 10px;
  @apply bg-indigo-600;
}
</style>
